<template>
  <span :class="itemClass">
    {{ item.status?.label }}
  </span>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    itemClass() {
      if (this.item.status) {
        return `badge ${
          this.item.status.name === 'completed'
            ? 'badge-success'
            : 'badge-danger'
        }`;
      }

      return '';
    }
  }
};
</script>
